var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.show,"z-index":"1002"},on:{"click":function($event){_vm.show = false}}},[_c('div',{staticClass:"reletive"},[_c('div',{staticClass:"open-browser"})])])}
var staticRenderFns = []

export { render, staticRenderFns }